import type { Product } from "@decocms/apps-commerce/types";

/**
 * Obtém a cor da variação selecionada do produto
 *
 * @param variant - Variação do produto (pode ser null ou undefined)
 * @returns Nome da cor formatado (primeira letra maiúscula) ou null se não encontrada
 */
export function getSelectedColor(
  variant: Product | null | undefined,
): string | null {
  if (!variant?.additionalProperty) return null;
  const colorProperty = variant.additionalProperty.find(
    (prop) => prop.name === "Cor",
  );
  const colorValue = colorProperty?.value;
  if (!colorValue) return null;
  return colorValue.charAt(0).toUpperCase() + colorValue.slice(1).toLowerCase();
}

/**
 * Gera um texto alt descritivo para imagens de produtos
 * Formato: "Nome do Produto + Imagem X" ou "Nome do Produto Cor + Imagem X" (se cor fornecida)
 *
 * @param productName - Nome do produto (pode ser undefined ou null)
 * @param imageIndex - Índice da imagem (0-based, será convertido para 1-based no texto)
 * @param color - Cor da variação selecionada (opcional)
 * @returns Texto alt descritivo ou fallback genérico
 */
export function getProductImageAlt(
  productName: string | null | undefined,
  imageIndex: number = 0,
  color?: string | null,
): string {
  const imageNumber = imageIndex + 1;
  const name = productName?.trim() || "Produto";
  const colorText = color?.trim() ? ` ${color.trim()}` : "";

  return `${name}${colorText} - Imagem ${imageNumber}`;
}
